"use strict";

require("./translate");